import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Divider, Form } from 'antd';
import { _success, _setAxios, _validationFormMsg } from '../../../../lib/Helper';

import { SelectTahunAjaran } from '../../../../components/select';
import { UploadFile } from '../../../../components/upload-files';

const schema = {
    tahun_ajaran_id: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
        };
    }

    componentDidMount() {
        this.setState({
            values: {
                id: this.props.data ? this.props.data.id : null,
                tahun_ajaran_id: this.props.data ? this.props.data.tahun_ajaran_id : null,
                file: null
            },
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        if(values.id){
            schema.file = null
        }else{
            schema.file = {
                presence: { allowEmpty: false, message: 'wajib dipilih' },
            }
        }
        const errors = validate(values, schema);
        if (errors) {
            return _validationFormMsg(errors)
        }
        this.setState({
            loading: true
        });
        const params = {
            tahun_ajaran_id: values.tahun_ajaran_id ? values.tahun_ajaran_id : null,
            file: values.file ? values.file : null,
        }

        let endpoint = "supervisi/instrumen"
        let method = "POST"
        if (values.id) {
            endpoint = endpoint + "/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        const { data } = this.props
        const { values } = this.state
        return (
            <Modal
                maskClosable={false}
                title={"Form Instrumen"}
                open={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Tahun Ajaran *">
                                <SelectTahunAjaran
                                    defaultValue={data.tahun_ajaran_id}
                                    value={values.tahun_ajaran_id}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("tahun_ajaran_id", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label={values.id ? "File" : "File *"}>
                                <UploadFile
                                    isValidation={true}
                                    type="pdf"
                                    onChange={(val) => {
                                        this.handleChangeSetValue("file", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default FormContent;
